export default class Validation {
    constructor(props) {
        this.rules = props.rules;
    }

    isValid(data) {
        this.data = data;
        let results = [];

        for(let key in data) {
            if(data.hasOwnProperty(key) && this.rules.hasOwnProperty(key)) {
                results.push(this.validate(this.rules[key], data[key]));
            }
        }

        return !results.includes(false);
    }

    validate(rule, value) {
        let isValid = false;
        let rules = [];

        if(rule.includes('|')) {
            rules = rule.split('|');
        }else {
            rules.push(rule);
        }

        rules.forEach((currentRule) => {
            switch(true) {
                case currentRule === 'required':
                    if(value) {
                        isValid = true;
                    }
                    break;
                case currentRule.includes('required_if_empty'):
                    let name = currentRule.split(':')[1];

                    if(this.data.hasOwnProperty(name)) {
                        if(this.data[name]) {
                            isValid = true;
                        }else {
                            if(value) {
                                isValid = true;
                            }
                        }
                    }else {
                        if(value) {
                            isValid = true;
                        }
                    }
                    break;
                default:
                    console.warn(`The rule ${rule} doesn't support.`)
            }
        });

        return isValid;
    }
}